module.exports = __webpack_public_path__ + "static/media/target_circle.ae632100.svg";